<template>
  <div class="col-lg-4 col-md-6 col-sm-6 px-2">
    <div class="wrapper" style="margin-bottom:10px;">
      
      <router-link
        :to="{ name: 'factsheet', params: { factsheet_id: item.identifier } }"
        v-bind:style="" class="item-link" 
      >

      
        <div class="item-header">
          <div class="row no-gutters align-items-center">
            <div class="col-lg">
              <div class="text-truncate">
              <h5 class="title text-truncate " v-if="item.location.name">
              <span class="item-type" :style="badgeStyle" v-bind:item="item" v-html="badgeLabel"></span>

                <i class="bi bi-files"></i> {{ item.location.name }}
              </h5>
              <h5 class="title" v-else>{{ item.location.identifier }}</h5>
              </div>
            </div>
          </div>


  <div class="row">
          <div class="col-lg-7 col-md-12 text-truncate" >
          <span class="" style="color:#888;padding-left:6px;">
     
              Created 25-11-2025 <!--
              {{ item.location.size }} sq. km-->
          </span>
        </div>
         <div class="col-5 text-right d-none d-lg-block" style="">
     <nobr>
        <span class="item-status item-ok" v-if="item.status == 0"
                ><i class="bi bi-clock"></i> <span class="d-md-none d-lg-inline">Processing</span></span
              >
              <span style="display:none;" class="item-status item-ok" v-if="item.status == 1"><i class="bi bi-check-circle"></i> Ready</span>

              <span class="item-status item-error" v-if="item.status == 2"
                >Error</span
              >
              <span class="item-status item-ok" v-if="item.status == 3"
                ><i class="bi bi-clock"></i> Processing</span
              >
              <span class="item-status item-error" v-if="item.status == 4"
                >Expired</span
              >
              <span class="item-status item-error" v-if="item.status == 6"
                >Deleted</span
              >
              <span class="item-status item-error" v-if="item.status == 5"
                >Error</span
              >
              </nobr>
            </div>



        </div>
           <div class="text-truncate" style="padding:4px;color:#999;display:none;"
            >
            <i class="bi bi-geo-alt-fill"></i>
            {{ item.location.size }} sq. km - 
            {{ item.location.city_distance }} km
            {{ item.location.city_bearing.toUpperCase() }} of
            {{ item.location.city_near }}
          </div>

        <img :src="previewUrl" class="img-fluid" style="margin-top:2px;min-width:100%;background-color:#f5f5f5;"/>


  


              </div>
      </router-link>
      

    </div>


   
  </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {};
  },
  computed: {
    previewUrl() {
      if (this.item.preview_path) {
        return (
          process.env.VUE_APP_API +
          "/data/factsheet" +
          this.item.preview_path +
          "/PreviewOpenstreetmap.jpg"
        );
      } else {
        return "";
      }
    },
    previewStyle() {
      if (this.previewUrl) {
        if((this.item.status == 4) || (this.item.status == 5) || (this.item.status == 2) || (this.item.status == 6)) {
          return (
          "background-image:url(" +
          this.previewUrl +
          ");background-position:center center;background-size:cover;filter:grayscale(0.9);opacity:0.8;pointer-events:none;"
        );
        } else {
          return (
          "background-image:url(" +
          this.previewUrl +
          ");background-position:center center;background-size:cover;"
        );
        }
        
      } else {
        return "background-color:#eee;";
      }
    },
    badgeStyle() {
      let factsheetType = this.item.factsheettype.name;
      let color ="color:#fff;background-color:" + this.item.factsheettype.color + ";";
      if ((factsheetType == 'basic') && (this.item.credit_applied.length > 0)) {
        color ="color:#fff;background-color:rgb(132, 186, 69);";
      }
      return (
        "border:none;border-radius:3px;font-size:14px;color:#fff;padding:1px 3px;margin-top:2px;margin-left:5px;margin-right:3px;" +
        color
      );
    },
    badgeLabel() {
      let factsheetType = this.item.factsheettype.name;
      if (factsheetType == 'basic') {
        if (this.item.credit_applied.length > 0) {
          return "Pro"
        }
      } else {
        return factsheetType.toUpperCase();
      }
      return "";
    }
  },
  props: ["item"],
  components: {},
  name: "Item",
};
</script>

<style></style>

<style scoped>
h5 {
  font-size: 1.2em;
  font-weight: bold;
}
li {
  width: 33.3334%;
  float: left;
  margin: 0px;
  padding: 0px;
  margin-bottom: 10px;
  list-style-type: none;
}


span.item-status {
  font-size: 16px;
  

  //background-color:#f5f5f5;
  padding: 1px 6px;
  border: none;
  //border-radius: 3px;
  //border-left:1px solid #ddd;
  //border-top:1px solid #ddd;
  //border-right:1px solid #ddd;
  display: inline-block;
}
span.item-type {
  background-color:#888;
  float:right;
  border: none;
  border-radius: 3px;
  display: inline-block;
  color:#fff;
  padding:2px;
}
span.item-status i {:
  font-size:0.9em;
}
li:nth-child(odd) div.wrapper {
  //padding-right:4px;
}
li:nth-child(even) div.wrapper {
  //padding-left:4px;
}
div.wrapper a,
div.wrapper div.expired {
  display: inline-block;
  width: 100%;
  border: 0px solid #ccc;
}
li a:hover {
  //background-color:#f5f5f5;
}

div.item-header {
  //background-color: rgba(255, 255, 255, 1);
  padding: 0px 0px;
  border-bottom: 0px solid #ccc;
}
li a:hover div.item-header {
  //background-color:#fff;
}
div.item-header h5 {
  padding: 9px 5px 4px 5px;
  margin: 0;
}
div.item-header h6 {
  padding: 0px 5px 2px 5px;
  color: #666;
  font-weight: bold;
  font-size: 0.9em;
}
div.item-preview {
  width: 100%;
  display: block;
}
div.item-footer {

  font-size: 0.9em;
  color: #666;
  pointer-events: none;
}
div.item-footer div.item-footer-content {
  
}
div.item-footer div.item-footer-world {

}
div.item-footer div.item-footer-content span {
  clear: left;
  margin-bottom: 3px;
  margin-left: 3px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
  padding: 1px 3px;
  color: #666;
}
div.item-footer div.location {
  display: inline;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  padding: 3px 5px;
  color: #fff;
}
div.item-footer div.size {
  padding-right: 5px;
  padding-top: 4px;
}
span.item-error {
  color: red;
}
span.item-ok {
  color: green;
}
span.item-empty {
  background-color:none;

}

a.item-link {
  background-color:#fff;
  border:1px solid #ddd !important;
}
a.item-link:hover {
  
  background-color:rgb(248, 248, 248);
  border:1px solid #ccc;
}
</style>
